import React, { useState } from "react";

import LogoD from "../assets/img/dynamic_logo.png";
import { SideNav, SimApps } from "../iconshere";
import { useSelector } from "react-redux";
import { Logout } from "../utils";
import { defaultLogo, applicationId, redirectUrl } from "../env";
import { useNavigate } from "react-router-dom";
import jwtEncode from "jwt-encode";

function Header() {
  const [switchToggled, setSwitchToggled] = useState(false);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const applications = useSelector((state) => state.applicationSlice).apps;

  const { user } = userData;
  const ToggleSwitch = () => {
    var body = document.body;
    if (switchToggled) {
      body.className = "";
      setSwitchToggled(false);
    } else {
      body.classList.add("sidebar-enable");
      body.classList.add("vertical-collpsed");
      setSwitchToggled(true);
    }
  };
  const navigate = useNavigate();

  const redirectApplication = (link) => {
    if (userData?.token && link) {
      const payload = { token: userData?.token };
      const token = jwtEncode(payload, "");

      if (link.includes("apps.simulanis.io")) {
        const newUrl = `${link}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `${link}?referrer=${token}`;
        window.location.href = newUrl;
      }
    }
  };

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="sidetoggle">
            <div
              className="ps-1"
              onClick={ToggleSwitch}
              id="vertical-menu-btn"
              style={{ cursor: "pointer", width: "25px", height: "25px" }}
            >
              <SideNav />
            </div>
            <div className="mainlogo LOGOHERE">
              <img src={configData.config.logo} alt="" onClick={() => navigate("/")} />
              <p>{configData.config.title}</p>
            </div>
            {/* <p className='currentpage'>Dashboard</p> */}
          </div>

          <div className="leftmain">
            <div className="profile">
              <div className="dropdown allapps">
                <div className="dropdown-menu sidebartopbar searchapplications">
                  <input className="input" name="text" placeholder="Search Applications" type="search" />
                  <h6>ALL SIMULANIS APPS</h6>
                  <div className="productlist">
                    <p>learn dsadasd dsadas</p>
                    <p>learn dsadasd dsadasds</p>
                    <p>learn adsadas dasd</p>
                    <p>learn asdasda </p>
                    <p>learndsadas sdad</p>
                    <p>learn</p>
                    <p>learn</p>
                    <p>learn</p>
                    <p>learn</p>
                    <p>learn</p>
                  </div>
                </div>
              </div>
              <div className="dropdown profileavatar">
                <p>{user.name}</p>
                <button
                  className="btn dropdown-toggle themetoggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="useravatar">
                    <img src={user.avatar} alt={user.name} referrerPolicy="no-referrer" />
                    {/* <img src={userData?.user?.avatar} alt={userData?.user?.name} title={userData?.user?.name} /> */}
                  </div>
                </button>
                <div className="dropdown-menu themehere popupon">
                  <div className="profilemenuhead" tabIndex="0">
                    <img src={user.avatar} referrerPolicy="no-referrer" alt={user.name} className="profilepik" />
                    <div className="profilemenudata">
                      <p>{user.name}</p>
                      <p>{user.email || user.uid}</p>
                    </div>
                  </div>
                  <p className="logoutbtn" onClick={() => Logout(userData.token, redirectUrl)}>
                    Log out
                  </p>
                </div>
              </div>
              <div className="dropdown profileavatar appnavigator  pe-2">
                <button
                  className="btn dropdown-toggle themetoggle p-0"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <SimApps />
                </button>
                <div className="dropdown-menu themehere popupon">
                  <div className="menu-long">
                    <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
                      {applications.map((e, i) => {
                        if (e.uuid === applicationId) return null;
                        return (
                          <div
                            className="appshere"
                            onClick={() => redirectApplication(e.channel?.origins[0]?.url)}
                            key={e.uuid}
                          >
                            <img
                              src={e.icon || defaultLogo}
                              onError={(e) => {
                                e.target.src = { defaultLogo };
                                e.onerror = null;
                              }}
                            />
                            <p> {e.name} </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
